// extracted by mini-css-extract-plugin
export default {"main":"PageNotFound_main__6-CQl","fof":"PageNotFound_fof__4fBww","type":"PageNotFound_type__dWCvA"};